import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  CrudContext,
  GridView,
  MasterDetailForm,
  Widget,
  FormatText,
  FormNumber,
  FormInput,
  FormDatePicker,
  FormSubmitButton,
  Button,
  FormTextArea,
  FormText,
} from '@digital/ui';
import {
  createPlanilhaOrcamento,
  getAllPlanilhasOrcadoEconomicoAnoMes,
  PlanilhaOrcadoEconomico,
  updatePlanilhaOrcadoEconomicoAnoMes,
} from '@app/api/planilhaOrcadoEconomicoAnoMes';
import UploadFile from '@app/components/uploadFile';
import { exportarPlanilhaOrcadoEconomicoAnoMes, exportaModelo } from '@app/api/exportaFile';
import { hasPermission } from '@app/helpers/permissions';
import PlanilhaOrcadoEconomicoAnoMesTabela from './PlanilhaOrcadoEconomicoAnoMesTabela';

const PlanilhaOrcadoEconomicoAnoMes = () => {
  const [planilhas, setPlanilhas] = useState(() => getAllPlanilhasOrcadoEconomicoAnoMes);
  const [hasFile, setHasFile] = useState(false);
  const [atualizarTela, setAtualizarTela] = useState<boolean>(false);
  const [planilhaOrcadoEconomico, setPlanilhaOrcadoEconomico] = useState<PlanilhaOrcadoEconomico>();

  const validationSchema = Yup.object().shape({
    numero: Yup.number().required('O número é obrigatório.'),
    revisao: Yup.string().required('Revisão é obrigatória.'),
    dataAprovacao: Yup.date().required('Data de Aprovação é obrigatória.'),
  });

  useEffect(() => {
    const fetchData = () => {
      setPlanilhas(() => Promise.resolve(undefined));
      setPlanilhas(() => getAllPlanilhasOrcadoEconomicoAnoMes);
    };

    fetchData();
  }, [atualizarTela]);

  const handleCreatePlanilhaOrcamento = (values: any) => {
    createPlanilhaOrcamento(values, values.formData).then(result => {
      if (result.valid) {
        
        setHasFile(true);
        setHasFile(false);
        setAtualizarTela(!atualizarTela);
        setPlanilhas(() => Promise.resolve(undefined));
        setPlanilhas(() => getAllPlanilhasOrcadoEconomicoAnoMes);
        //window.location.href = '/moduloOrcado/planilhaOrcadoEconomicoAnoMes';
        window.location.href = `/moduloOrcado/planilhaOrcadoEconomicoAnoMes/detail/${result && result.id}`;
      }
    });
  };

  const exportarModelo = (modelo: string) => {
    if (modelo) {
      exportaModelo(modelo);
    }
  };

  return (
    <CrudMasterDetailView
      getAllItems={planilhas}
      createItem={hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) ? Promise.resolve(undefined) : undefined}
      updateItem={hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) ? Promise.resolve(undefined) : undefined}
      disableNotification
      icon="business-estimate"
      detailTitleExtractor={x => `PLANILHA ORÇADO ECONÔMICO ANO MÊS ${x.numero}`}
      filterPredicate={(item, value) =>
        item.numero
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()) || (item.ano ? item.ano.toString().startsWith(value.toLowerCase()) : false)
      }
      titleExtractor={item => `Planilha ${item.numero}`}
      descriptionExtractor={item => `Rev: ${item.revisao} - ${item.ano}`}>
      <CrudContext.Consumer>
        {({ selectedItem }) => {
          setPlanilhaOrcadoEconomico(selectedItem);

          return (
            <GridView noform>
              <MasterDetailForm
                validationSchema={validationSchema}
                onSubmit={values => {
                  handleCreatePlanilhaOrcamento(values, selectedItem);
                }}>
                <Widget
                  title="Dados da Planilha"
                  actions={[
                    <Button
                      type="link"
                      icon="files-xls"
                      onClick={() => {
                        exportarModelo('modeloOrcadoAnual');
                      }}>
                      Modelo de importação Anual
                    </Button>,
                    hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) && (
                      <Button
                        type="link"
                        icon="files-xls"
                        onClick={() => {
                          exportarPlanilhaOrcadoEconomicoAnoMes(selectedItem.id, 'planilhaOrcadoEconomico.xlsx');
                        }}>
                        Exportar Planilha
                      </Button>
                    ),
                    hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) && (
                      <FormSubmitButton
                        type="primary"
                        onClick={values => {
                          if (selectedItem) values.id = selectedItem.id;

                          if (selectedItem) {
                            updatePlanilhaOrcadoEconomicoAnoMes(values);
                          } else {
                            handleCreatePlanilhaOrcamento(values);
                          }
                        }}>
                        <FormatText id="ui.commons.save" uppercase />
                      </FormSubmitButton>
                    ),
                  ]}>
                  <FormNumber label="Número" name="numero" span={3} disabled={selectedItem} />
                  <FormInput label="Revisão" name="revisao" span={3} disabled={selectedItem} />
                  <FormDatePicker
                    label="Data de Aprovação"
                    name="dataAprovacao"
                    format="DD/MM/YYYY"
                    span={3}
                    required
                    disabled={selectedItem}
                  />
                  {selectedItem && <FormInput label="Status" name="statusPlanilha" disabled span={3} />}
                  <FormTextArea label="Observação" name="observacao" span={12} />
                  {!selectedItem && hasPermission(['ORCADO_ECONOMICO_ANUAL_EDITAR_ABA_INDEX']) && (
                    <UploadFile
                      hasFile={hasFile}
                      accept=".xlsx"
                      label="Incluir planilha"
                      id="importFilePlanilha"
                      selectedItem={selectedItem}
                    />
                  )}
                </Widget>
              </MasterDetailForm>
              {selectedItem ? (
                <PlanilhaOrcadoEconomicoAnoMesTabela atualizarTelaProp={atualizarTela} projeto={selectedItem} />
              ) : (
                  <> </>
                )}
            </GridView>
          );
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default PlanilhaOrcadoEconomicoAnoMes;
